// extracted by mini-css-extract-plugin
module.exports = {"Item":"sustainable-development__Item_8pWQS"};